import { render, staticRenderFns } from "./loinx.vue?vue&type=template&id=361bbd80&"
import script from "./loinx.vue?vue&type=script&lang=js&"
export * from "./loinx.vue?vue&type=script&lang=js&"
import style0 from "./loinx.vue?vue&type=style&index=0&id=361bbd80&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports